module.exports = __webpack_public_path__ + "img/writing.e127ba7b.svg";